import { gql } from '@apollo/client';

export const PlannedYearContributions = gql`
  query PlannedYearContributions($year: Int!) {
    financePlan(year: $year) {
      month
      USD
      EUR
      BYN
      RUB
      PLN
    }
    financeBudget(year: $year) {
      month
      USD
      EUR
      BYN
      RUB
      PLN
    }
  }
`;

export const PlannedMonthContributions = gql`
  query PlannedMonthContributions($year: Int!, $month: Int!) {
    financeMonthBudget(year: $year, month: $month) {
      plan {
        week
        USD
        EUR
        BYN
        RUB
        PLN
      }

      budget {
        week
        USD
        EUR
        BYN
        RUB
        PLN
      }
    }
  }
`;

export const FinanceYears = gql`
  query FinanceYears {
    financeYears
  }
`;
